<div class="vertical-container-simple column-gap-1"> <!-- this wraps everything, delete after refactor finish -->
  <ng-container *ngIf="showLoadingState">
    <div *ngFor="let _ of [0, 1]" class="card holding fms-container row-gap-4">

      <div class="vertical-container-simple column-gap-2">
        <div class="width-6 height-1p5 br-0p5 bg-black-4"></div>
        <div class="row-container row-gap-0p5">
          <div class="width-1 height-1 br-0p25 bg-black-4"></div>
          <div class="width-10 height-1 br-0p25 bg-black-4"></div>
        </div>
      </div>

      <div class="row-container row-gap-1">
        <div *ngFor="let width of [18, 18, 8, 8, 8, 8]" class="vertical-container-simple column-gap-0p5">
          <div class="width-7 bg-black-4 height-0p75 br-0p5"></div>
          <div class="bg-black-4 height-2p5 br-0p5 width-{{width}}"></div>
        </div>
      </div>
    </div>
  </ng-container>

  <div *ngIf="isStandalone" class="flex row-gap-1"> <!--this wraps top piece, tabs and values and current status, delete after refactor finish -->
    <div class="section-item-wrapper width-50vw">
      <app-tabs
        data-qa="holding-sensitivity-tabs"
        class="row-gap-1"
        [tabNamesRaw]="holdingTabs"
        [isGrey]="true"
        (selectedTabEmitter)="selectedTabEmitterResolution($event)">
      </app-tabs>
      <div class="row-container row-gap-1 column-gap-1 padding-0p625-1">
        <div class="flex-column column-gap-1 flex-grow-1">
          <app-selector
            data-qa="esop-selector"
            [selectedItem]="esopSelectorData[0]"
            [title]="'ESOP issue'"
            [data]="esopSelectorData"
            [disabled]="isTarget"
            [isNotInTable]="true"
            (itemEmitter)="setEsopType($event)"
          />
          <app-input
            data-qa="pre-money-round-input"
            class="flex-grow-1"
            [input]="xSeries[0]"
            [title]="isTarget ? 'Pre-money value' : 'Round size'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            (inputChange)="updateRoundsAndInvestments($event, isTarget ? ROUND_DETAILS_PROPERTIES.PRE_MONEY : ROUND_DETAILS_PROPERTIES.ROUND, true)"
          />
          <app-input
            data-qa="round-investment-input"
            class="flex-grow-1"
            [input]="ySeries[0]"
            [title]="isTarget ? 'Round size' : 'Investment'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            (inputChange)="updateRoundsAndInvestments($event, isTarget ? ROUND_DETAILS_PROPERTIES.ROUND : ROUND_DETAILS_PROPERTIES.INVESTMENT, true)"
          />
          <app-input
            *ngIf="isTarget"
            data-qa="target-holding-input"
            class="flex-grow-1"
            [input]="roundDetails.targetHoldingInput"
            [title]="'Target holding, %'"
            [thousandSeparator]="','"
            (inputChange)="roundDetails.targetHoldingInput = $event; recalculatePredictions()"
          />
          <app-input
            *ngIf="selectedTab === 'Holding prediction'"
            data-qa="pre-money-start-value"
            class="flex-grow-1"
            [input]="roundDetails.preMoney.startValue"
            [title]="'Pre-Money'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            (inputChange)="updateRoundsAndInvestments($event, ROUND_DETAILS_PROPERTIES.PRE_MONEY, true)"
          />
        </div>
        <div class="flex-column column-gap-1 flex-grow-1">
          <app-input
            data-qa="esop-percentage-input"
            class="flex-grow-1"
            [input]="esopPercentageInput"
            [title]="'ESOP rate'"
            [suffix]="'%'"
            [separator]="'separator.2'"
            [thousandSeparator]="','"
            (inputChange)="esopPercentageInput = $event; recalculatePredictions()"
          />
          <div *ngIf="isTarget" class="flex-column column-gap-1 flex-grow-1">
            <app-input
              data-qa="pre-money-round-step"
              class="flex-grow-1"
              [input]="roundDetails.preMoney.step"
              [separator]="'separator.0'"
              [title]="'Pre-money value step'"
              [thousandSeparator]="','"
              (inputChange)="updateRoundsAndInvestments($event, ROUND_DETAILS_PROPERTIES.PRE_MONEY, false)"
              />
            <app-input
              data-qa="round-investment-step"
              class="flex-grow-1"
              [input]="roundDetails.round.step"
              [separator]="'separator.0'"
              [title]="'Round size step'"
              [thousandSeparator]="','"
              (inputChange)="updateRoundsAndInvestments($event, ROUND_DETAILS_PROPERTIES.ROUND, false)"
              />
          </div>
          <div *ngIf="!isTarget" class="centered-column-container column-gap-1 flex-grow-1">
            <app-input
              data-qa="pre-money-round-step"
              class="flex-grow-1"
              [input]="roundDetails.round.step"
              [separator]="'separator.0'"
              [title]="'Round size step'"
              [thousandSeparator]="','"
              (inputChange)="updateRoundsAndInvestments($event, ROUND_DETAILS_PROPERTIES.ROUND, false)"
              />
            <app-input
              data-qa="round-investment-step"
              class="flex-grow-1"
              [input]="roundDetails.investment.step"
              [separator]="'separator.0'"
              [title]="'Inv. size step'"
              [thousandSeparator]="','"
              (inputChange)="updateRoundsAndInvestments($event, ROUND_DETAILS_PROPERTIES.INVESTMENT, false)"
            />
          </div>
          <div *ngIf="isTarget" class="whitespace-like-input"></div>
        </div>
      </div>
    </div>
    <div class="section-item-wrapper width-50vw vertical-container-simple column-gap-1">
      <span class="font-1 bold600">Current status</span>
      <app-selector
        data-qa="company-selector"
        [selectedItem]="selectedCompany"
        [title]="'Select company'"
        [data]="companies"
        [field]="'name'"
        [isNotInTable]="true"
        (itemEmitter)="selectedCompany = $event; setHoldingBeforeRoundPercentage(true)">
      </app-selector>
      <div *ngIf="selectedCompany?.valuationRoundValue" class="vertical-container column-gap-0p5">
        <div class="centered-row-container row-gap-0p5">
          <div class="vertical-container grey-info-card width-100pcnt">
            <span class="font-4 bold600">Investment</span>
            <span class="font-2 bold600">
              {{selectedCompany.cost | switcherDashBraces:1:1}}
            </span>
          </div>
          <div class="vertical-container grey-info-card width-100pcnt">
            <span class="font-4 bold600">Fair value</span>
            <span class="font-2 bold600">
              {{selectedCompany.fairValue | switcherDashBraces:1:1}}
            </span>
          </div>
          <div class="vertical-container grey-info-card width-100pcnt">
            <span class="font-4 bold600">Company value</span>
            <span class="font-2 bold600">
              {{selectedCompany.valuationRoundValue | switcherDashBraces:1:1}}
            </span>
          </div>
        </div>
        <div class="centered-row-container row-gap-0p5">
          <div class="vertical-container grey-info-card width-100pcnt">
            <span class="font-4 bold600">Holding</span>
            <span class="font-2 bold600">
              {{selectedCompany.holdingPercentage | percent:'1.2-2' | dashInsteadOfNull}}
            </span>
          </div>
          <div class="vertical-container grey-info-card width-100pcnt">
            <span class="font-4 bold600">MOIC</span>
            <span class="font-2 bold600">
              x{{selectedCompany.fairValue/selectedCompany.cost | number:'1.2-2' | dashInsteadOfNull}}
            </span>
          </div>
          <div class="vertical-container grey-info-card width-100pcnt">
            <span class="font-4 bold600">IRR</span>
            <span class="font-2 bold600">
              {{selectedCompany.calculatedGrossIrr | percent:'1.2-2' | dashInsteadOfNull}}
            </span>
          </div>
        </div>
      </div>
      <span class="font-4">{{descriptions.disclaimerText}}
      </span>
      <div class=" bg-black-3 br-0p5 aligned-row-container row-gap-0p5 padding-0p5">
        <app-all-icons [iconNameAndStyling]="'prediction-three-bars-chart.svg; icon-size-3'"></app-all-icons>
        <label class="width-100pcnt font-3 black-12">{{descriptions.useCaseText}}</label>
      </div>
    </div>
  </div>

  <div *ngIf="!isStandalone && selectedCompany && !showLoadingState" class="card holding fms-container">
    <div class="font-2 bold500 settings">Settings</div>
    <div class="child-wrapper first-block">
      <div class="start-row-container align-items-center row-gap-0p5">
        <app-checkbox
          data-qa="isTarget-checkbox"
          [checked]="isTarget"
          (checkBoxClicked)="isTarget = !isTarget; setHoldingBeforeRoundPercentage()"
        />
        <span>{{ holdingTabs[0] }}</span>
      </div>

      <div class="input-wrap">
        <app-input
          *ngIf="isTarget"
          data-qa="target-holding-input"
          [input]="roundDetails.targetHoldingInput"
          [thousandSeparator]="','"
          [separator]="'separator.2'"
          [suffix]="'%'"
          (inputChange)="roundDetails.targetHoldingInput = $event; recalculatePredictions()"
        />
      </div>
    </div>
    <div class="child-wrapper">
      <app-input
        data-qa="esop-percentage-input"
        class="input-wrap"
        [input]="esopPercentageInput"
        [title]="'New ESOP, %'"
        [suffix]="'%'"
        [separator]="'separator.2'"
        [thousandSeparator]="','"
        (inputChange)="esopPercentageInput = $event; recalculatePredictions()">
      </app-input>
    </div>
    <div class="child-wrapper">
      <app-input
        data-qa="pre-money-start-input"
        class="input-wrap"
        [input]="roundDetails[ROUND_DETAILS_PROPERTIES.PRE_MONEY].startValue"
        [title]="'Pre-money value'"
        [separator]="'separator.0'"
        [thousandSeparator]="','"
        (inputChange)="updateRoundsAndInvestments($event, ROUND_DETAILS_PROPERTIES.PRE_MONEY, true)"
      />
    </div>
    <div class="child-wrapper">
      <app-input
        data-qa="round-size-input"
        class="input-wrap"
        [input]="roundDetails[ROUND_DETAILS_PROPERTIES.ROUND].startValue"
        [title]="'Round size'"
        [separator]="'separator.0'"
        [thousandSeparator]="','"
        (inputChange)="updateRoundsAndInvestments($event, ROUND_DETAILS_PROPERTIES.ROUND, true)"
      />
      <app-input
        data-qa="round-step-input"
        class="input-wrap"
        [input]="roundDetails[ROUND_DETAILS_PROPERTIES.ROUND].step"
        [separator]="'separator.0'"
        [title]="'Step'"
        [thousandSeparator]="','"
        (inputChange)="updateRoundsAndInvestments($event, ROUND_DETAILS_PROPERTIES.ROUND, false)"
      />
    </div>
    <div *ngIf="!isTarget" class="child-wrapper">
      <app-input
        data-qa="investment-start-input"
        class="input-wrap"
        [input]="roundDetails[ROUND_DETAILS_PROPERTIES.INVESTMENT].startValue"
        [title]="'Investment'"
        [separator]="'separator.0'"
        [thousandSeparator]="','"
        (inputChange)="updateRoundsAndInvestments($event, ROUND_DETAILS_PROPERTIES.INVESTMENT, true)"
      />
      <app-input
        data-qa="investment-step-input"
        class="input-wrap"
        [input]="roundDetails[ROUND_DETAILS_PROPERTIES.INVESTMENT].step"
        [separator]="'separator.0'"
        [title]="'Step'"
        [thousandSeparator]="','"
        (inputChange)="updateRoundsAndInvestments($event, ROUND_DETAILS_PROPERTIES.INVESTMENT, false)"
      />
    </div>
  </div>

  <app-holding-loan-conversion
    [data]="loanInitialData"
    [preMoney]="roundDetails.preMoney.startValue"
    [preMoneyStep]="roundDetails[ROUND_DETAILS_PROPERTIES.PRE_MONEY].step"
    [isTarget]="isTarget"
    (emitLoanData)="loanData = $event; recalculatePredictions()">
  </app-holding-loan-conversion>

  <!----------------//////----------------------TABLES---------------------///////----------------->
  <div>
    <app-holding-target-table
      [isTarget]="isTarget"
      [borderMatrix]="borderMatrix"
      [xSeries]="xSeries"
      [ySeries]="ySeries"
      [gradientMatrix]="gradientMatrix"
      [predictionsMatrix]="predictionsMatrix"
      [selectedTab]="selectedTab"
    />
    <ng-container *ngIf="isTarget && selectedCompany?.cost">
      <app-holding-fmv-investment-table class="margin-1"
        [isTarget]="isTarget"
        [borderMatrix]="borderMatrix"
        [xSeries]="xSeries"
        [ySeries]="ySeries"
        [gradientMatrix]="gradientMatrix"
        [predictionsMatrix]="predictionsMatrix"
        [selectedTab]="selectedTab"
        [targetHolding]="targetHolding"
        [selectedCompany]="selectedCompany"
      />
      <app-holding-moic-table class="margin-1"
        [isTarget]="isTarget"
        [borderMatrix]="borderMatrix"
        [xSeries]="xSeries"
        [ySeries]="ySeries"
        [gradientMatrix]="gradientMatrix"
        [predictionsMatrix]="predictionsMatrix"
        [selectedTab]="selectedTab"
        [targetHolding]="targetHolding"
        [selectedCompany]="selectedCompany"
      />
    </ng-container>


    <!-------------------------------------// PREDICTION TABLE //--------------------------------------->
    <div *ngIf="!isTarget && selectedCompany?.valuationRoundValue">
      <app-holding-pmv-investment-table
        [isTarget]="isTarget"
        [borderMatrix]="borderMatrix"
        [xSeries]="xSeries"
        [ySeries]="ySeries"
        [gradientMatrix]="gradientMatrix"
        [predictionsMatrix]="predictionsMatrix"
        [selectedTab]="selectedTab"
        [esopType]="esopType"
        [esopPercentage]="esopPercentage"
        [selectedCompany]="selectedCompany"
        [roundDetails]="roundDetails"
      />
    </div>
  </div>
</div> <!-- delete after refactor finish -->
